import pick from 'lodash/pick'
import { AnyAction } from 'redux'

import { LINKCLICK } from '../constants'
import instrumentAction from '../instrumentAction'

const SCHEMA = ['name', 'placement'] as const

export function trackLinkClick<
    Props extends { name?: string | null; placement?: string | null },
>(action: AnyAction, href: string | null, properties: Props = {} as Props) {
    return instrumentAction(action, LINKCLICK, {
        href,
        properties: pick(properties, SCHEMA),
    })
}
